export const PRIVACY_POLICY_URL = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0';
export const PERSONAL_DATA_URL =
  'https://cdn.cian.site/frontend/info-assets/cpd/soglasheniye_na_obrabotku_perdata.docx';
export const MARKETING_AGREEMENT_URL =
  'https://www.cian.ru/legal-documents/soglasie_na_poluchenie_reklamnyx_rassylok_0';
export const PHONE_MASK = '+7 (000) 000-00-00';
export const PHONE_UNMASKED_LENGTH = PHONE_MASK.replace(/[^0]/g, '').length;
